import step01Image from "../../../media/img/home/how-it-work-section/01.png";
import step02Image from "../../../media/img/home/how-it-work-section/02.png";
import step03Image from "../../../media/img/home/how-it-work-section/03.png";

const HowItWorks = () => {
  const steps = [
    {
      id: 1,
      title: "Models",
      description:
        "Access to cutting-edge AI models from leading providers. Choose from text generation, image creation, and specialized models. Filter and search to find the perfect model for your needs.",
      image: step01Image,
      features: [
        "Multiple AI providers",
        "Specialized models",
        "Easy model switching",
      ],
    },
    {
      id: 2,
      title: "Usage Overview",
      description:
        "Monitor your AI usage with detailed analytics. Track high-end tokens, images, and web searches in real-time. Get insights into your consumption patterns and optimize your workflow.",
      image: step02Image,
      features: [
        "Real-time usage tracking",
        "Detailed analytics",
        "Usage optimization tips",
      ],
    },
    {
      id: 3,
      title: "Billing",
      description:
        "Transparent billing with no hidden costs. View your current bill, track monthly charges, and manage your subscription. Get detailed breakdowns of all usage-based charges.",
      image: step03Image,
      features: [
        "Transparent pricing",
        "Monthly billing cycles",
        "Detailed cost breakdown",
      ],
    },
  ];

  return (
    <section className="py-20 bg-bg-70">
      <div className="w-[90%] max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-6 h-6 rounded-full bg-fg-60 flex items-center justify-center">
              <span className="text-bg-60 text-xs font-bold">@</span>
            </div>
            <h2 className="text-fg-60 text-base font-medium">How it work</h2>
          </div>
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            <span className="text-fg-60">Enhance efficiency</span>{" "}
            <span className="text-fg-40">and</span>
            <br />
            <span className="text-fg-40">productivity</span>
          </h1>
          <p className="text-fg-60 text-base max-w-2xl mx-auto">
            LeebAI generates high-converting proposals with AI, helping you
            close more deals without wasting time.
          </p>
        </div>

        {/* Steps Stack */}
        <div className="space-y-6">
          {steps.map((step) => (
            <div key={step.id} className="bg-bg-50 rounded-2xl overflow-hidden">
              <div className="grid lg:grid-cols-2 gap-0">
                {/* Left Side - Step Content */}
                <div className="p-8 lg:p-12 flex flex-col justify-center">
                  <div className="space-y-6">
                    <div>
                      <h3 className="text-2xl font-bold text-fg-40 mb-4">
                        {step.title}
                      </h3>
                      <p className="text-fg-60 text-base leading-relaxed mb-6">
                        {step.description}
                      </p>
                    </div>

                    {/* Features List with smaller bullet circles */}
                    <div className="space-y-3">
                      {step.features.map((feature, featureIndex) => (
                        <div
                          key={featureIndex}
                          className="flex items-center gap-3"
                        >
                          <div className="w-1.5 h-1.5 bg-ac-02 rounded-full flex-shrink-0"></div>
                          <span className="text-fg-60 text-sm">{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Right Side - Step Image with increased padding and no bottom padding */}
                <div className="flex items-stretch pt-6 pr-6 pl-6 pb-0 lg:pt-10 lg:pr-10 lg:pl-10 lg:pb-0">
                  <img
                    src={step.image}
                    alt={step.title}
                    className="w-full h-full object-cover object-left"
                    draggable="false"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
